var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9a2eeb533716de9791d0fc6d9ed7070ca6b73ab2"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["u-short@abortnikovru"]={id:"9a2eeb533716de9791d0fc6d9ed7070ca6b73ab2"};
      